import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Contact from './Pages/Contact/Contact';
import Portfolio from './Pages/Portfolio/Portfolio';
import PageNotFound from './PageNotFound';
import Services from "./Pages/Services/Services";
import './App.css';
import Products from './Pages/Products/Products';
import Pricing from './Pages/Pricing/Pricing';
import BlogList from './Pages/Blog/BlogList';
import BlogDetail from './Pages/Blog/BlogDetail';
import Chatbot from './Components/Chatbot/Chatbot';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import { CMSProvider } from './context/CMSContext';

// Solution & Industry Landing Pages
import SolutionDetail from './Pages/Services/SolutionDetail';
import IndustryDetail from './Pages/Industries/IndustryDetail';

// Admin Pages
import AdminLogin from './Pages/Admin/AdminLogin';
import AdminDashboard from './Pages/Admin/AdminDashboard';
import ManageTeam from './Pages/Admin/ManageTeam';
import ManageProjects from './Pages/Admin/ManageProjects';
import ManageProducts from './Pages/Admin/ManageProducts';
import ManagePlans from './Pages/Admin/ManagePlans';
import ManageBot from './Pages/Admin/ManageBot';
import ManageBlogs from './Pages/Admin/ManageBlogs';
import InternalProjects from './Pages/Dashboard/Admin/InternalProjects';
import ManageCMS from './Pages/Dashboard/Admin/ManageCMS';

// Portal Pages
import PortalLogin from './Pages/PortalAuth/Login';
import PortalLayout from './layouts/PortalLayout';
import AdminOverview from './Pages/Dashboard/Admin/AdminOverview';
import ManageUsers from './Pages/Dashboard/Admin/ManageUsers';
import ManageTasks from './Pages/Dashboard/Admin/ManageTasks';
import ManageAttendance from './Pages/Dashboard/Admin/ManageAttendance';
import InternOverview from './Pages/Dashboard/Intern/InternOverview';
import DailyTasks from './Pages/Dashboard/Intern/DailyTasks';
import Attendance from './Pages/Dashboard/Intern/Attendance';
import Learning from './Pages/Dashboard/Intern/Learning';
import Performance from './Pages/Dashboard/Intern/Performance';
import EmployeeOverview from './Pages/Dashboard/Employee/EmployeeOverview';
import ProjectManagement from './Pages/Dashboard/Employee/ProjectManagement';
import Profile from './Pages/Dashboard/Profile';

function App() {
  const location = useLocation();
  const isAppRoute = !location.pathname.startsWith('/admin') &&
    !location.pathname.startsWith('/portal') &&
    !location.pathname.startsWith('/dashboard');

  return (
    <CMSProvider>
      {isAppRoute && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/offers" element={<Pricing />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:idOrSlug" element={<BlogDetail />} />

        {/* Dedicated Solution Landing Routes */}
        <Route path="/crm-development" element={<SolutionDetail />} />
        <Route path="/erp-development" element={<SolutionDetail />} />
        <Route path="/ai-automation" element={<SolutionDetail />} />
        <Route path="/software-development" element={<SolutionDetail />} />
        <Route path="/web-development" element={<SolutionDetail />} />
        <Route path="/digital-marketing" element={<SolutionDetail />} />
        <Route path="/ui-ux-design" element={<SolutionDetail />} />

        {/* Dedicated Industry Solution Routes */}
        <Route path="/solutions/:industryId" element={<IndustryDetail />} />

        {/* Admin Routes - Legacy (keeping login) */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Portal Auth */}
        <Route path="/portal/login" element={<PortalLogin />} />

        {/* Portal Dashboards */}
        <Route path="/dashboard" element={<PortalLayout />}>
          {/* Admin */}
          <Route path="admin" element={<AdminOverview />} />
          <Route path="admin/users" element={<ManageUsers />} />
          <Route path="admin/tasks" element={<ManageTasks />} />
          <Route path="admin/attendance" element={<ManageAttendance />} />
          <Route path="admin/team" element={<ManageTeam />} />
          <Route path="admin/projects" element={<ManageProjects />} />
          <Route path="admin/internal-projects" element={<InternalProjects />} />
          <Route path="admin/products" element={<ManageProducts />} />
          <Route path="admin/plans" element={<ManagePlans />} />
          <Route path="admin/blogs" element={<ManageBlogs />} />
          <Route path="admin/bot" element={<ManageBot />} />
          <Route path="admin/cms" element={<ManageCMS />} />
          <Route path="admin/profile" element={<Profile />} />

          {/* Intern */}
          <Route path="intern" element={<InternOverview />} />
          <Route path="intern/tasks" element={<DailyTasks />} />
          <Route path="intern/projects" element={<ProjectManagement />} />
          <Route path="intern/attendance" element={<Attendance />} />
          <Route path="intern/learning" element={<Learning />} />
          <Route path="intern/performance" element={<Performance />} />
          <Route path="intern/profile" element={<Profile />} />

          {/* Employee */}
          <Route path="employee" element={<EmployeeOverview />} />
          <Route path="employee/tasks" element={<DailyTasks />} />
          <Route path="employee/projects" element={<ProjectManagement />} />
          <Route path="employee/attendance" element={<Attendance />} />
          <Route path="employee/profile" element={<Profile />} />
        </Route>
      </Routes>

      {isAppRoute && <Chatbot />}
      {isAppRoute && <ScrollToTop />}
      {isAppRoute && <Footer />}
    </CMSProvider>
  );
}

export default App;
